const columns = [
  {
    title: "内容板块",
    links: [
      { label: "今日热搜", href: "#hot" },
      { label: "投票打榜", href: "#poll" },
      { label: "舞台直拍", href: "#stage" },
      { label: "热议八卦", href: "#gossip" },
    ],
  },
  {
    title: "深度专区",
    links: [
      { label: "导师点评", href: "#mentor" },
      { label: "淘汰内幕", href: "#eliminate" },
      { label: "常见问题", href: "#faq" },
      { label: "关于本站", href: "#about" },
    ],
  },
  {
    title: "互动",
    links: [
      { label: "投稿线索", href: "#contact" },
      { label: "订阅动态", href: "#contact" },
      { label: "给我们写信", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="container-x py-12">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-primary-600 text-lg text-background-50">
                <i className="ri-megaphone-fill" aria-hidden="true" />
              </span>
              <span className="leading-none">
                <span className="block font-serif text-2xl font-black text-foreground-950">每日大赛</span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.22em] text-primary-600">
                  DailyContest
                </span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-[13px] leading-6 text-foreground-700">
              选秀打榜与吃瓜的第一现场。汇总投票打榜攻略、舞台直拍对比与淘汰内幕复盘，
              坚持"呈现证据、不做定论"的编辑原则，让你看得懂、吃得明。
            </p>
            <div className="mt-5 flex flex-col gap-2 text-[13px] text-foreground-700">
              <a href="#contact" className="inline-flex items-center gap-2 hover:text-primary-600">
                <i className="ri-mail-line" aria-hidden="true" />
                hello@dailycontest.cn
              </a>
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title} className="lg:col-span-2" aria-label={col.title}>
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="inline-flex items-center gap-1.5 text-[13px] text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      <i className="ri-arrow-right-s-line text-primary-400" aria-hidden="true" />
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="lg:col-span-1">
            <h4 className="text-sm font-bold text-foreground-950">栏目</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {["打榜", "直拍", "八卦", "导师", "内幕"].map((c) => (
                <a
                  key={c}
                  href="#hot"
                  className="chip border border-secondary-300 bg-background-50/60 text-secondary-800 hover:border-primary-400 hover:text-primary-700"
                >
                  {c}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-300/70 pt-6">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs leading-5 text-foreground-600">
              免责声明：本站内容均为对公开播出信息与社交平台讨论的二次整理评析，事实与观点分开标注，
              未证实信息明确标注"存疑"，不构成对任何个体或组织的结论性判断。
            </p>
            <p className="shrink-0 text-xs text-foreground-600">
              © {new Date().getFullYear()} 每日大赛网 · 保留所有权利
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}